import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Linear',
  content: `
A Linear connection lets agents search tickets, create them, comment on them and change their status. Through the **Pliable Linear app**, tickets and comments post as the app, not as a person; with an API key, they post as the key's owner.

An agent only writes to tickets it created or linked in its current piece of work, and only in the teams you allow.

---

## 1. Add the connection in Pliable

1. Open the **Agents** page and find **Connections**.
2. Choose **Linear** and give the connection a name (for example \`ops-linear\`).
3. With **Pliable Linear app** selected, click **Install in Linear**, choose your workspace and approve. Installing needs a Linear admin. You come back to the new connection.

A workspace has one Pliable Linear app connection; give each step its own teams.

**Using an API key instead:** in Linear, open **Settings → Security & access → Personal API keys**, create a key (consider a dedicated Linear user for your agents), then choose **API key** here, paste it and click **Add connection**.

---

## 2. Use it in an agent

Give each step only what it needs, naming the teams by key:

\`\`\`json
"capabilities": [
  { "connection": "ops-linear", "capability": "ticket.search", "params": { "teams": ["ENG"] } },
  { "connection": "ops-linear", "capability": "ticket.link", "params": { "teams": ["ENG"] } },
  { "connection": "ops-linear", "capability": "ticket.create", "params": { "team": "ENG", "labels": ["Bug"] } },
  { "connection": "ops-linear", "capability": "ticket.comment", "params": {} }
]
\`\`\`

- **ticket.search**: find tickets, in the listed teams (all teams if none).
- **ticket.link**: attach a ticket it found to the current piece of work, so it may comment on it.
- **ticket.create**: create a ticket in one team, with only the listed labels.
- **ticket.comment**, **ticket.status**: comment on, or move, a linked ticket.

To have a person approve a new ticket first, put an approval gate on the hand-off to the step that creates it (see **Slack**).

---

## Troubleshooting

| What you see | What to do |
|---|---|
| A Linear tool fails with "Authentication required" | The key was revoked or mistyped. Create a new one and use **Replace secret**. |
| A run fails with "Linear refused the token request" | The Pliable Linear app was uninstalled or its access revoked. Delete the connection and install the app again. |
| The agent can't comment on a ticket | It can only comment on tickets it created or linked; give the step **ticket.link** for that ticket's team. |
`,
};

export default doc;
